import { LayoutComponent } from '../layout/layout.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { RecoverComponent } from './pages/recover/recover.component';
import { LockComponent } from './pages/lock/lock.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { Error404Component } from './pages/error404/error404.component';
import { Error500Component } from './pages/error500/error500.component';
import { GuardService } from "../core/auth/guard.service";
import { ManageGuard } from "../core/manage/manage.guard";
import { IncomesComponent } from './controllers/incomes/incomes.component';
import { ExpensesComponent } from './controllers/expenses/expenses.component';
import { OneTimeFeesComponent } from './controllers/one-time-fees/one-time-fees.component';
import { VendorsComponent } from "./debts/vendors/vendors.component";
import { CustomersComponent } from "./debts/customers/customers.component";
import { OutletsComponent } from "./debts/outlets/outlets.component";
import { FeesComponent } from "./configs/fees/fees.component";
import { ApplicationComponent } from "./configs/fees/application/application.component";
import { ServicesComponent } from './debts/services/services.component';
import {MergeTransferComponent} from "./utilities/merge-transfer/merge-transfer.component";
import {GatewaysComponent} from "./controllers/gateways/gateways.component";
import {VoucherComponent} from "./controllers/voucher/voucher.component";
import {AhaPointComponent} from './controllers/aha-point/aha-point.component';
import {GeneralComponent} from './general/general.component';
import {PendingIesComponent} from './controllers/pending-ies/pending-ies.component';
import { TransferComponent } from './ice-cream/transfer/transfer.component';


export const routes = [

  {
    path: '',
    component: LayoutComponent,
    canActivate: [GuardService],
    children: [
      // { path: '', redirectTo: 'general', pathMatch: 'full' },
      { path: '', redirectTo: 'debts/outlets', pathMatch: 'full' },
      { path: 'general', component: GeneralComponent, canActivate: [ManageGuard] },
      { path: 'debts/outlets', component: OutletsComponent },
      { path: 'debts/vendors', component: VendorsComponent },
      { path: 'debts/customers', component: CustomersComponent },
      { path: 'debts/services', component: ServicesComponent },
      { path: 'controllers/incomes', component: IncomesComponent },
      { path: 'controllers/expenses', component: ExpensesComponent },
      { path: 'controllers/one-time-fees', component: OneTimeFeesComponent },
      { path: 'controllers/gateways', component: GatewaysComponent },

      { path: 'controllers/pending-ies', component: PendingIesComponent},
      // { path: 'controllers/voucher', component: VoucherComponent },
      { path: 'controllers/aha-point', component: AhaPointComponent },

      { path: 'ice-cream/transfer', component: TransferComponent },

      { path: 'utilities/merge-transfer', component: MergeTransferComponent },
      
      { path: 'configs/fees', component: FeesComponent },
      { path: 'configs/fees/application', component: ApplicationComponent },
    ]
  },
  // Not lazy-loaded routes
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'recover', component: RecoverComponent },
  { path: 'lock', component: LockComponent },
  { path: 'maintenance', component: MaintenanceComponent },
  { path: '404', component: Error404Component },
  { path: '500', component: Error500Component },

  // Not found
  { path: '**', redirectTo: '404' }
];
